import { clamp } from '@anton.bobrov/vevet-init';
import { useEventListener, useEvent, isNumber, isString } from '@anton.bobrov/react-hooks';

function useFormSelectOptionNavigation({
  ref,
  options,
  isActive,
  onSelect,
  focusedId,
  onFocus
}) {
  useEventListener({
    ref,
    target: "keydown",
    listener: (event) => {
      if (event.key !== "Home") {
        return;
      }
      event.preventDefault();
      onFocus(options[0].id);
    },
    isDisabled: !isActive
  });
  useEventListener({
    ref,
    target: "keydown",
    listener: (event) => {
      if (event.key !== "End") {
        return;
      }
      event.preventDefault();
      onFocus(options[options.length - 1].id);
    },
    isDisabled: !isActive
  });
  const handleUpDown = useEvent((direction) => {
    const currentIndex = options.findIndex(({ id }) => id === focusedId);
    let nextIndex = null;
    if (currentIndex === -1) {
      if (direction === "up") {
        nextIndex = options.length - 1;
      } else {
        nextIndex = 0;
      }
    } else if (direction === "up") {
      nextIndex = clamp(currentIndex - 1, [0, options.length - 1]);
    } else {
      nextIndex = clamp(currentIndex + 1, [0, options.length - 1]);
    }
    const nextOption = options[nextIndex];
    if (nextOption) {
      onFocus(nextOption.id);
    }
  });
  useEventListener({
    ref,
    target: "keydown",
    listener: (event) => {
      if (event.key === "ArrowUp") {
        event.preventDefault();
        handleUpDown("up");
      }
    },
    isDisabled: !isActive
  });
  useEventListener({
    ref,
    target: "keydown",
    listener: (event) => {
      if (event.key === "ArrowDown") {
        event.preventDefault();
        handleUpDown("down");
      }
    },
    isDisabled: !isActive
  });
  useEventListener({
    ref,
    target: "keydown",
    listener: (event) => {
      if ((event.key === "Enter" || event.key === " ") && (isNumber(focusedId) || isString(focusedId))) {
        event.preventDefault();
        onSelect(focusedId);
      }
    },
    isDisabled: !isActive
  });
}

export { useFormSelectOptionNavigation };
//# sourceMappingURL=useFormSelectOptionNavigation.js.map
